import * as $ from 'jquery';

import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

import { SearchCountryField, CountryISO, NgxIntlTelInputComponent } from '@khazii/ngx-intl-tel-input';

import { FormBase } from '@shared/form-base.component';
import { Subscription } from 'rxjs';
import { Country } from '@shared/models/Enums';


@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent extends FormBase<any> implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(NgxIntlTelInputComponent) intlTelInput: NgxIntlTelInputComponent;

    @Input() label: 'Teléfono';
    @Input() formGroup: UntypedFormGroup;
    @Input() country = Country.CR;
    @Input() isScratch: boolean = false;


    @Output() change: EventEmitter<any> = new EventEmitter<any>();
    @Output() blur: EventEmitter<any> = new EventEmitter<any>();

    // ngx-intl-tel-input
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO; // Type definition for use in HTML
    preferredCountries = [
        CountryISO.CostaRica, CountryISO.Panama, CountryISO.Mexico,
        CountryISO.Colombia, CountryISO.Nicaragua, CountryISO.Guatemala
    ];

    // Country (enum Givi) → CountryISO del componente de teléfono
    private static readonly COUNTRY_ISO_MAP: { [key: number]: CountryISO } = {
        [Country.CR]: CountryISO.CostaRica,
        [Country.PA]: CountryISO.Panama,
        [Country.MX]: CountryISO.Mexico,
        [Country.CO]: CountryISO.Colombia,
        [Country.NI]: CountryISO.Nicaragua,
        [Country.GT]: CountryISO.Guatemala,
    };

    phoneLength: number = 8; // default costa rica
    placeholder = '';

    isInit = true;
    
    selectedCountry = this.CountryISO.CostaRica;
    private formChangesSubscription: Subscription;

    constructor(private cdr: ChangeDetectorRef) {
        super();
    }


    ngOnInit() {
        this.formChangesSubscription = this.formGroup.valueChanges.subscribe(values => {
            if (values?.phone && values?.country && values?.country != this.country) {

                this.selectedCountry = PhoneInputComponent.COUNTRY_ISO_MAP[values.country] || this.CountryISO.CostaRica;

                this.cdr.detectChanges();
            }
        });

        this.selectedCountry = PhoneInputComponent.COUNTRY_ISO_MAP[this.country] || this.CountryISO.CostaRica;
    }

    ngOnDestroy() {
        if (this.formChangesSubscription) this.formChangesSubscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {

        for (const propName in changes) {
            if (propName === 'formGroup') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    // Refresh
                    this.formGroup = null;
                    this.formGroup = this.formGroup;
                    
                    this._phoneInit();
                }
            }
        }
    }

    ngAfterViewInit() {

        //change or re select the country to avoid invalid errors
        setTimeout(() => {

            // Datos por país para armar el evento inicial (CR es el default)
            const countryDefaults: { [key: number]: any } = {
                [Country.CR]: { dialCode: '506', iso2: 'cr', name: 'Costa Rica', placeHolder: '8888 8888' },
                [Country.PA]: { dialCode: '507', iso2: 'pa', name: 'Panama', placeHolder: '8888-8888' },
                [Country.MX]: { dialCode: '52',  iso2: 'mx', name: 'Mexico', placeHolder: '55 1234 5678' },
                [Country.CO]: { dialCode: '57',  iso2: 'co', name: 'Colombia', placeHolder: '301 2345678' },
                [Country.NI]: { dialCode: '505', iso2: 'ni', name: 'Nicaragua', placeHolder: '8123 4567' },
                [Country.GT]: { dialCode: '502', iso2: 'gt', name: 'Guatemala', placeHolder: '5123 4567' },
            };

            const data = countryDefaults[this.country] || countryDefaults[Country.CR];
            const ev = {
                areaCodes: undefined,
                dialCode: data.dialCode,
                flagClass: `iti__${data.iso2}`,
                htmlId: `iti-0__item-${data.iso2}`,
                iso2: data.iso2,
                name: data.name,
                placeHolder: data.placeHolder,
                priority: 0
            };

            this.onCountryChange(ev);

        },100);

        this._phoneInit();

        // Suscribir el evento blur del input phone
        $('#phone').on("blur", () => this.blur.next(this.phone?.value));
    }

    onCountryChange(ev: any) {
        
        const areaCode = `+${ev.dialCode}`;
        if(ev.iso2 == 'pa') ev.placeHolder = '8888-8888';

        // Convierte el placeholder actual en dígitos de 8
        const placeholder = ev.placeHolder.replace(areaCode, '').trim()
            .split('').map(x => x > 0 ? '8' : x).join('');
        //La mascara sin espacios
        const phoneMask = placeholder.replace(/ /g, '').replace(/-/g, '').trim();

        // Update UI
        setTimeout(x => {
            this.placeholder = placeholder;
            this.phoneLength = phoneMask.length;
        });

        if (this.isInit) return;

        // hide input errors
        if (this.phone?.value) this.touched = false;

        // Se actualiza el max validator
        this.phone.setValidators([Validators.required, Validators.minLength(this.phoneLength)]);

        // Se limpia el valor
        this.phone.setValue({ number: '', countryCode: ev.iso2?.toUpperCase(), dialCode: areaCode });
        setTimeout(x => this.phone.updateValueAndValidity(), 100);
    }

    onModelChange(ev: any) {

        if (this.isInit) return;

        // hide input errors
        if (this.phone?.value) this.touched = false;

        this.change.next(this.phone?.value)
    }


    // { number: '', countryCode: 'CR', dialCode: '+506' }
    get phone() { return this._formGet(this.formGroup, 'phone'); }
    get invalidPhone(): boolean {
        return this._setPhoneValidators();
    }


    private _phoneInit() {

        if (this.phone?.value?.dialCode && this.phone?.value?.number) {

            // Valor original cuando se hace Init del componente
            const dialCode = this.phone.value?.dialCode.replace('+', '');
            const countryCode = this.intlTelInput.allCountries.find(x => x.dialCode == dialCode);
            const phoneValue = {
                number: this.phone.value?.number,
                countryCode: countryCode.iso2,
                dialCode: this.phone.value?.dialCode
            };
            // Se refresca el valor actual al original del Init
            setTimeout(() => {
                this.phone.setValue(phoneValue);
                this.phone.updateValueAndValidity();
            }, 100);
        }

        this.isInit = false;
    }

    private _setPhoneValidators() {

        if (this.phone?.errors && this.phone?.touched) {

            // Requerido
            if (this.phone.errors?.required || this.phone.errors?.minLength) {
                return true;
            }
            // Formato invalido o incompleto  
            else if (this.phone.errors?.validatePhoneNumber) {
                const number = this.phone?.value?.number.replace(/ /g, '').replace(/-/g, '').trim();
                if (number.length < this.phoneLength) {
                    // Setear que error es por que esta incompleto
                    setTimeout(() => { this.phone.setErrors({ minLength: { valid: false } }); });
                }
                return true;
            }
        }
        return false;
    }
}
